import { Member } from "@/models/member";
import { Pagination } from "@/models/pagination";
import { IMember, MemberState } from "@/types/member";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<MemberState, IMember> = {
  single: (state, single) => {
    state.single = new Member(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new Member(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new Member();
    state.pagination = new Pagination();
  },
};

export default mutations;
